import { ActionStatus } from './action-status.entity';
import { ActionDisabledCondition } from './user-action.entity';

export class BatchUserAction {
    private actionStatus: ActionStatus;
    private availableConditions: boolean[];
    private disabledConditions: ActionDisabledCondition[];

    constructor(availableConditions: boolean[], disabledConditions: ActionDisabledCondition[]) {
        this.availableConditions = availableConditions;
        this.disabledConditions = disabledConditions;

        this.initActionStatus();

        const generalDisabledCondition: ActionDisabledCondition = {
            condition: this.isDisabled(),
            tooltip: 'general.batch-actions'
        };
        this.disabledConditions.push(generalDisabledCondition);
    }

    /**
     * Batchaction Status
     *
     * Actionable → actionable for all
     * Unavailable → not available for all
     * Disabled → other (mixed cases)
     */
    private initActionStatus(): void {
        const batchAvailable: boolean = this.availableConditions.every(condition => condition === true);

        const unavailable = !batchAvailable;

        if (unavailable) {
            this.actionStatus = ActionStatus.Unavailable;
            return;
        }

        const batchDisabled: boolean = this.disabledConditions.some(
            disabledCondition => disabledCondition.condition === true
        );

        const disabled = batchDisabled;

        this.actionStatus = disabled ? ActionStatus.NotActionable : ActionStatus.Actionable;
    }

    public getDisabledCondition(): ActionDisabledCondition | undefined {
        return this.disabledConditions.find(disabledCondition => disabledCondition.condition === true);
    }

    public isAvailable(): boolean {
        return this.actionStatus !== ActionStatus.Unavailable;
    }

    public isDisabled(): boolean {
        return this.actionStatus === ActionStatus.NotActionable;
    }

    public isEnabled(): boolean {
        return this.actionStatus === ActionStatus.Actionable;
    }
}
